import React from 'react'
import styled from 'styled-components'
import { Row } from 'react-bootstrap'

export default () => (
  <>
    <Row>
      <Title>Комплексное оснащение объектов под ключ</Title>
    </Row>
  </>
)

const Title = styled.h2`
  margin: 30px auto 50px;
  text-align: center;
  opacity: 1;
  @media screen {
    font-size: 3rem;
  }
`
